import { useState, useEffect, useContext } from 'react'
import styled from '@emotion/styled'
import { t } from '@lingui/core/macro'
import { Typography } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { CvsChipInput } from '@components'
import { api } from 'api'
import { updateIntegrationNotification } from '../../template.actions'
import { templateCopyContext } from '../context'

const MarginFormControl = styled(FormControlLabel)`
  display: flex;
`

export const NotificationEmailConfig = ({ connectorId, integrationAssignmentId }) => {
  const dispatch = useDispatch()
  const { template } = useContext(templateCopyContext)
  const [emailOnFailure, setEmailOnFailure] = useState(false)
  const notifications = useSelector(state => state.Template.integrationNotifications, shallowEqual)
  const notification = notifications[integrationAssignmentId] || {
    id: null,
    emailTo: [],
    emailOnFailure: false,
    connectorId,
  }

  const onEmailToChange = val => {
    updateTemplateNotification(val, 'emailTo')
  }

  const updateTemplateNotification = (fieldValue, fieldName) => {
    const updateNotificiation = { ...notification }
    updateNotificiation[fieldName] = fieldValue
    updateNotificiation.subject = emailOnFailure
      ? `There was an integration error on the template: [${template.template.name}]`
      : ''
    dispatch(updateIntegrationNotification(integrationAssignmentId, updateNotificiation))
  }

  useEffect(() => {
    async function getData() {
      const { data } = await api.get(
        `/api/v1/integration-email-notifications/${integrationAssignmentId}`,
      )
      data.map(notification => {
        dispatch(
          updateIntegrationNotification(integrationAssignmentId, {
            id: notification.id,
            emailTo: JSON.parse(notification.email_to),
            emailSubject: notification.subject,
            emailOnFailure: notification.email_on_failure,
            emailOnSuccess: notification.email_on_success,
            integrationAssignmentId,
            connectorId,
          }),
        )
      })
    }
    getData()
  }, [integrationAssignmentId])

  return (
    <>
      <MarginFormControl
        size="small"
        control={
          <Checkbox
            checked={notification.emailOnFailure}
            onClick={({ target: { checked } }) => {
              setEmailOnFailure(checked)
              updateTemplateNotification(checked, 'emailOnFailure')
            }}
          />
        }
        label={t`Email on failure`}
      />
      {notification.emailOnFailure ? (
        <>
          <CvsChipInput
            placeholder={t`example@claravine.com (Enter)`}
            label={t`Recipients`}
            value={notification.emailTo}
            onChange={val => onEmailToChange(val)}
            required={emailOnFailure}
            style={{ minWidth: '450px' }}
          />
          <Typography
            style={{
              margin: '8px 0 0 5px',
              fontSize: '12px',
              fontFamily: 'noto-sans, sans-serif',
              color: 'rgba(0,0,0,.54)',
            }}
          >
            {t`Enter a list of email addresses to notify if there is an error with this integration.`}
          </Typography>
        </>
      ) : null}
    </>
  )
}

NotificationEmailConfig.propTypes = {}
